// extracted by css-extract-rspack-plugin
export default {"wrapper":"BudgetInput-module__wrapper--Bkhvm"};